'use strict';

function Config() {
  this.data = {};
}

Config.prototype.get = function (id, fallback) {
  if (typeof fallback === 'undefined') {
    throw new Error('Must provide a fallback value');
  }

  if (this.data.hasOwnProperty(id)) {
    return this.data[id];
  } else {
    return fallback;
  }
};

Config.prototype.set = function (id, value) {
  this.data[id] = value;
};

var config = new Config();

module.exports = config;
